const camelToUnderscore = (inputString) => {
  return inputString.replace(/[A-Z]/g, (match) => {
    return "_" + match.toLowerCase();
  });
};

export default camelToUnderscore;
